import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const getCoupon = (code: string) => {
    return arriereBackoffice.queries.coupon({
      __alias: 'getCoupon',
      __args: {
        code,
      },
      code: true,
      description: true,
      salesFrom: true,
      salesTo: true,
      bookingPeriodType: true,
      bookingFrom: true,
      bookingTo: true,
      maximumDiscount: true,
      maximumUsages: true,
      minimumPrice: true,
      minimumStay: true,
      discountType: true,
      discountValue: true,
      applicableTo: true,
      homes: {
        id: true,
        name: true,
        region: {
          name: true,
        },
        revenueModel: true,
        links: {
          listings: {
            leadSource: true,
            url: true,
          },
        },
      },
      createdAt: true,
      isActive: true,
      usages: true,
      cancellationPolicyRule: true,
    })
  }
